/* ============ template config ============ */
var CFG=window.GENIC_PDP||{};var selectedOpt=CFG.preselect||0;
/* GENIC Jul 26 2026 - P0 guards: a missing config or filtered-out option can never
   throw. options may arrive empty (sold out / product unpublished) - renderOpts
   closes the buy surface quietly instead of dying mid-boot. */
if(!CFG.options)CFG.options=[];
if(selectedOpt>=CFG.options.length)selectedOpt=0;
(function(){try{
  var q=new URLSearchParams(location.search);
  var want=q.get('set')?('set'+q.get('set')):(q.get('v')?('sd'+q.get('v')):null);
  if(want&&CFG.options)CFG.options.forEach(function(o,i){if(o.id===want)selectedOpt=i;});
}catch(e){}})();

function money(n){return '$'+(n%1?n.toFixed(2):n);}
var toastTimer=null;
function toast(msg){
  var t=document.getElementById('toast');t.innerHTML=msg;t.classList.add('on');
  clearTimeout(toastTimer);toastTimer=setTimeout(function(){t.classList.remove('on');},2200);
}

/* the scarcity ring */
function setRing(f){
  var r=document.getElementById('p-ring');if(!r)return;
  var C=40.84;
  f=Math.max(0.04,Math.min(1,(f==null?1:f)));
  r.style.strokeDasharray=C;
  r.style.strokeDashoffset=(C*(1-f)).toFixed(2);
}

function renderOpts(){
  var p=CFG,w=document.getElementById('p-opts'),h='';
  if(!p.options.length){
    /* sold-out / missing-product state: the page stays whole, buying quietly closes */
    if(w)w.innerHTML='';
    var atc=document.getElementById('atc-main');
    if(atc){atc.textContent='SOLD OUT';atc.disabled=true;}
    var st=document.getElementById('p-status');if(st)st.textContent='ARCHIVED';
    var sbs=document.getElementById('sb-status');if(sbs)sbs.textContent='ARCHIVED';
    var sb=document.getElementById('stickybar');if(sb)sb.style.display='none';
    var cl=document.getElementById('p-clarity');if(cl)cl.innerHTML='';
    var ct=document.getElementById('p-contents');if(ct)ct.classList.remove('on');
    var fk=document.getElementById('f-k-story');if(fk)fk.textContent=p.storyK||'';
    var ps=document.getElementById('p-story');if(ps)ps.innerHTML=p.story||'';
    setRing(0);
    return;
  }
  if(selectedOpt>=p.options.length)selectedOpt=0;
  if(p.options.length>1){
    p.options.forEach(function(o,i){
      var lb=o.label,nm=lb,pr='',ix=lb.indexOf(' — ');
      if(ix>-1){nm=lb.slice(0,ix);pr=lb.slice(ix+3);}
      h+='<button class="opt'+(i===selectedOpt?' sel':'')+(o.badge?' badged':'')+'" onclick="selOpt('+i+')">'
        +(o.badge?'<span class="opt-tag">'+o.badge+'</span>':'')
        +'<span class="opt-n">'+nm+'</span>'
        +(pr?'<span class="opt-p">'+(o.compare&&o.compare>o.price?'<s class="opt-c">'+money(o.compare)+'</s>':'')+pr+'</span>':'')
        +'</button>';
    });
  }
  w.innerHTML=h;
  var o=p.options[selectedOpt];
  document.getElementById('atc-main').textContent='ADD TO CART — '+money(o.price);
  document.getElementById('p-clarity').innerHTML=o.clarity;
  document.getElementById('p-status').textContent=o.status||p.status;
  document.getElementById('sb-status').textContent=o.statusShort||p.statusShort||o.status||p.status;
  document.getElementById('sb-name').textContent=p.title.replace('CAPSULE ','')+' · '+money(o.price);
  setRing(o.frac!=null?o.frac:p.frac);
  document.getElementById('f-k-story').textContent=o.storyK||p.storyK;
  document.getElementById('p-story').innerHTML=o.story||p.story;
  if(o.poster&&p.object==='poster'){document.getElementById('object-poster').src=o.poster;}
  var c=document.getElementById('p-contents');
  if(o.contents){
    var wasOpen=c.classList.contains('on');
    if(!wasOpen||c.childElementCount!==o.contents.length){
      var ch='';o.contents.forEach(function(it){
        ch+='<div class="c-card"><div class="im"><img loading="lazy" draggable="false" class="'+(it.blend?'mult':'')+'" src="'+it.src+'" alt="" onerror="this.style.display=\'none\'"></div><div class="lb">'+it.label+'</div></div>';
      });
      c.innerHTML=ch;
      void c.offsetHeight;
    }else{
      var lbs=c.querySelectorAll('.lb'),ims=c.querySelectorAll('.c-card img');
      o.contents.forEach(function(it,i){
        if(lbs[i])lbs[i].textContent=it.label;
        if(ims[i]&&ims[i].getAttribute('src')!==it.src)ims[i].setAttribute('src',it.src);
      });
    }
    c.classList.add('on');
  }else{c.classList.remove('on');}
}
function selOpt(i){selectedOpt=i;renderOpts();}

/* ============ GENIC cart sync — Horizon-native (Ryan Jul 22) ============
   Root cause of the ~30s 'lag': the old code dispatched 'cart:refresh' (nothing
   listens) and poked Dawn selectors (.cart-count-bubble / [data-cart-count]) that
   do not exist in this Horizon theme - so cart-icon.js never heard the add and the
   header count only corrected on the next page load.

   Fix: speak the theme's own language. Dispatch the native 'cart:update' event with
   the true item_count. cart-icon.js updates the bubble in the same tick; cart-items-
   component re-renders the drawer (morphs from our sections, or self-fetches fresh).
   We SET the absolute count (not increment) so the bubble can never drift.

   cart_type is 'drawer' with auto_open - but Ryan's confirmation is the toast, not a
   black drawer sliding over the paper PDP. So we strip auto-open on this page: the
   count updates, the drawer stays closed, and it is correct whenever opened. */
function genicCollectCartSectionIds(){
  var ids=[];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
    var s=el.dataset.sectionId; if(s&&ids.indexOf(s)<0) ids.push(s);
  });
  return ids;
}
function genicSuppressDrawerAutoOpen(){
  document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function(d){ d.removeAttribute('auto-open'); });
}
function genicDispatchCartUpdate(data){
  var resource=data.resource||{}; delete data.resource;
  document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:resource,sourceId:'genic-pdp',data:data}}));
}

function addSelected(btn){
  var o=CFG.options[selectedOpt];
  if(!o){return;}
  var prev='ADD TO CART — '+money(o.price);
  if(!o.variantId){btn.textContent='UNAVAILABLE';setTimeout(function(){btn.textContent=prev;},1600);return;}
  btn.textContent='ADDING…';
  var payload={items:[{id:o.variantId,quantity:1}]};
  var sectionIds=genicCollectCartSectionIds();
  if(sectionIds.length) payload.sections=sectionIds.join(',');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)})
    .then(function(r){if(!r.ok)throw 0;return r.json();})
    .then(function(added){
      btn.textContent='ADDED';
      toast('IN THE CART — <a href="/cart" style="color:inherit;text-decoration:underline;">REVIEW →</a>');
      genicSuppressDrawerAutoOpen();
      var sections=(added&&added.sections)||undefined;
      var pid=(added&&added.product_id)?String(added.product_id):undefined;
      /* authoritative count from the cart, then hand the theme its own event */
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
        genicDispatchCartUpdate({resource:cart,source:'genic-pdp',itemCount:cart.item_count,productId:pid,sections:sections});
        try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(cart.item_count),timestamp:Date.now()}));}catch(e){}
      }).catch(function(){
        /* rare: cart.js failed - fall back to native increment (never zeroes the bubble) */
        genicDispatchCartUpdate({source:'product-form-component',itemCount:1,productId:pid,sections:sections});
      });
      setTimeout(function(){btn.textContent=(btn.id==='atc-main')?prev:'ADD TO CART';},1600);
    })
    .catch(function(){btn.textContent=prev;toast('COULD NOT ADD — TRY AGAIN');});
}
function expressCheckout(){
  var o=CFG.options[selectedOpt];
  if(o&&o.variantId)window.location='/cart/'+o.variantId+':1';
}

/* ============ THE ARCHIVE — depth carousel ============ */
var CAR={items:[],n:0,pos:0,target:0,vel:0,S:420,dragging:false,idle:true};
var carEl=document.getElementById('carousel');
var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function buildCarousel(p){
  carEl.querySelectorAll('.ci').forEach(function(e){e.remove();});
  CAR.items=[];
  p.gallery.forEach(function(f,i){
    var d=document.createElement('div');
    d.className='ci';
    d.innerHTML='<div class="num">'+String(i+1).padStart(2,'0')+'</div><img decoding="async" draggable="false" src="'+f+'" alt="" onerror="this.style.visibility=\'hidden\'">';
    d.addEventListener('click',function(){ if(!CAR.wasDrag) CAR.target=i; });
    carEl.appendChild(d);
    CAR.items.push(d);
  });
  CAR.n=p.gallery.length;
  CAR.pos=0;CAR.target=0;CAR.vel=0;CAR.idle=false;
  layoutCar(true);
  updateCount();
}
function carSpacing(){CAR.S=window.innerWidth<700?Math.max(window.innerWidth*0.62,230):Math.min(500,window.innerWidth*0.38);}
carSpacing();window.addEventListener('resize',function(){carSpacing();CAR.idle=false;});

function layoutCar(force){
  for(var i=0;i<CAR.items.length;i++){
    var off=i-CAR.pos;
    var ao=Math.abs(off);
    var x=off*CAR.S;
    var ry=-Math.max(-2,Math.min(2,off))*16;
    var z=-Math.min(ao,3)*170;
    var s=1-Math.min(ao*0.08,0.26);
    var op=ao>3.2?0:1-Math.max(0,ao-2.2)*0.55;
    var el=CAR.items[i];
    el.style.transform='translate(-50%,-50%) translateX('+x.toFixed(2)+'px) translateZ('+z.toFixed(1)+'px) rotateY('+ry.toFixed(2)+'deg) scale('+s.toFixed(3)+')';
    el.style.filter='blur('+Math.min(7,ao*3.4).toFixed(2)+'px)';
    el.style.opacity=op.toFixed(3);
    el.style.zIndex=String(100-Math.round(ao*10));
    el.style.visibility=op<=0?'hidden':'visible';
  }
}
function updateCount(){
  var i=Math.max(0,Math.min(CAR.n-1,Math.round(CAR.pos)));
  document.getElementById('arch-count').textContent=String(i+1).padStart(2,'0')+' / '+String(CAR.n).padStart(2,'0');
}
var carVisible=true;
new IntersectionObserver(function(en){carVisible=en[0].isIntersecting;},{threshold:0.05}).observe(carEl);
(function carLoop(){
  requestAnimationFrame(carLoop);
  if(!carVisible)return;
  if(RM){
    if(CAR.pos!==CAR.target){CAR.pos=CAR.target;layoutCar();updateCount();}
    return;
  }
  if(CAR.dragging)return;
  var d=CAR.target-CAR.pos;
  if(Math.abs(d)<0.0008){
    if(!CAR.idle){CAR.pos=CAR.target;layoutCar();updateCount();CAR.idle=true;}
    return;
  }
  CAR.idle=false;
  CAR.pos+=d*0.05;
  layoutCar();
  updateCount();
})();

/* drag / swipe */
(function(){
  var startX=0,startY=0,startPos=0,lastX=0,lastT=0,v=0,decided=false,pending=false,pid=null;
  carEl.addEventListener('pointerdown',function(e){
    pending=true;decided=(e.pointerType==='mouse');
    startX=lastX=e.clientX;startY=e.clientY;startPos=CAR.pos;v=0;lastT=performance.now();
    CAR.wasDrag=false;pid=e.pointerId;
    if(decided){CAR.dragging=true;carEl.classList.add('dragging');carEl.setPointerCapture&&carEl.setPointerCapture(pid);}
  });
  carEl.addEventListener('pointermove',function(e){
    if(!pending&&!CAR.dragging)return;
    if(!decided){
      var adx=Math.abs(e.clientX-startX),ady=Math.abs(e.clientY-startY);
      if(adx<7&&ady<7)return;
      if(adx<ady*1.4){pending=false;return;}
      decided=true;CAR.dragging=true;carEl.classList.add('dragging');
      carEl.setPointerCapture&&carEl.setPointerCapture(pid);
    }
    if(!CAR.dragging)return;
    if(e.cancelable)e.preventDefault();
    var now=performance.now(),dx=e.clientX-lastX;
    v=dx/Math.max(1,now-lastT);
    lastX=e.clientX;lastT=now;
    CAR.pos=startPos-(e.clientX-startX)/CAR.S;
    CAR.pos=Math.max(-0.35,Math.min(CAR.n-0.65,CAR.pos));
    if(Math.abs(e.clientX-startX)>6)CAR.wasDrag=true;
    layoutCar();updateCount();
  },{passive:false});
  function up(){
    if(!CAR.dragging&&!pending){return;}
    pending=false;
    if(CAR.dragging){
      CAR.dragging=false;carEl.classList.remove('dragging');
      var fling=Math.max(-1.0,Math.min(1.0,-v*2.5));
      CAR.target=Math.max(0,Math.min(CAR.n-1,Math.round(CAR.pos+fling)));
      CAR.vel=0;CAR.idle=false;
    }
  }
  window.addEventListener('pointerup',up);
  window.addEventListener('pointercancel',up);
})();

/* develop-on-scroll + sticky */
(function(){
  var els=document.querySelectorAll('.dev');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});
  },{threshold:0.1});
  els.forEach(function(e){io.observe(e);});
})();
(function(){
  var bar=document.getElementById('stickybar'),atc=document.querySelector('.buy .genic-lcb');
  var io=new IntersectionObserver(function(en){
    var shopEl=document.getElementById('shop');var shopOn=shopEl&&shopEl.classList.contains('on');
    bar.classList.toggle('on',!en[0].isIntersecting&&!shopOn);
  },{threshold:0.2});
  io.observe(atc);
})();

/* ============ GENIC Liquid Chrome Button — verbatim GLSL (v7) ============ */
(function(){
  var frag=[
    'precision mediump float;',
    'uniform float u_time;',
    'varying vec2 vUv;',
    'void main() {',
    '  vec2 uv = vUv * 2.0 - 1.0;',
    '  float t = u_time * 0.15;',
    '  vec2 p = uv;',
    '  for(float i = 1.0; i < 6.0; i++) {',
    '    uv.x += 0.4 / i * cos(i * 2.0 * uv.y + t);',
    '    uv.y += 0.4 / i * cos(i * 1.5 * uv.x + t);',
    '  }',
    '  float f = cos(uv.x + uv.y);',
    '  float chrome = smoothstep(-0.1, 0.1, f);',
    '  float r = smoothstep(-0.1, 0.1, cos(uv.x + uv.y + 0.05));',
    '  float g = smoothstep(-0.1, 0.1, cos(uv.x + uv.y + 0.10));',
    '  float b = smoothstep(-0.1, 0.1, cos(uv.x + uv.y + 0.15));',
    '  vec3 color = vec3(r, g, b);',
    '  float edge = 1.0 - smoothstep(0.0, 0.2, abs(f));',
    '  vec3 finalColor = mix(vec3(chrome), color, edge * 0.9);',
    '  finalColor = smoothstep(vec3(0.05), vec3(0.95), finalColor);',
    '  finalColor = 0.45 + 0.55 * finalColor;',
    '  gl_FragColor = vec4(finalColor, 1.0);',
    '}'
  ].join('\n');
  var vert='attribute vec2 a; varying vec2 vUv; void main(){ vUv = a * 0.5 + 0.5; gl_Position = vec4(a, 0.0, 1.0); }';
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initLCB(wrap){
    if(wrap.dataset.genicInit)return;
    wrap.dataset.genicInit='1';
    var canvas=wrap.querySelector('.genic-lcb__canvas');
    var gl=canvas.getContext('webgl',{alpha:true,antialias:true});
    if(!gl){wrap.classList.add('genic-lcb--nogl');return;}
    function sh(type,src){var s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);return s;}
    var prog=gl.createProgram();
    gl.attachShader(prog,sh(gl.VERTEX_SHADER,vert));
    gl.attachShader(prog,sh(gl.FRAGMENT_SHADER,frag));
    gl.linkProgram(prog);
    if(!gl.getProgramParameter(prog,gl.LINK_STATUS)){wrap.classList.add('genic-lcb--nogl');return;}
    gl.useProgram(prog);
    var buf=gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER,buf);
    gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),gl.STATIC_DRAW);
    var loc=gl.getAttribLocation(prog,'a');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
    var uTime=gl.getUniformLocation(prog,'u_time');
    function size(){
      var r=wrap.getBoundingClientRect();
      var dpr=Math.min(window.devicePixelRatio||1,1.5);
      canvas.width=Math.max(1,Math.round(r.width*dpr));
      canvas.height=Math.max(1,Math.round(r.height*dpr));
      gl.viewport(0,0,canvas.width,canvas.height);
    }
    size();
    window.addEventListener('resize',size,{passive:true});
    var start=Date.now(),running=true,raf=null;
    function frame(){
      gl.uniform1f(uTime,(Date.now()-start)/1000);
      gl.drawArrays(gl.TRIANGLE_STRIP,0,4);
      if(running&&!reduce)raf=requestAnimationFrame(frame);
    }
    if(reduce){frame();return;}
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        var vis=entries[0].isIntersecting&&!document.hidden;
        if(vis&&!running){running=true;frame();}
        else if(!vis){running=false;if(raf)cancelAnimationFrame(raf);}
      }).observe(wrap);
    }
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){running=false;if(raf)cancelAnimationFrame(raf);}
      else if(!running){running=true;frame();}
    });
    frame();
  }
  document.querySelectorAll('[data-lcb]').forEach(initLCB);
})();

/* boot - one product per page. TAILSMAN: the landing cover app (loaded as page scripts)
   renders itself into #genic-tailsman-hero / #gt-stage - no iframe, the landing's proven path.
   Here we only run the touch gate so page scroll stays free until the visitor opts in. */
(function initProduct(){
  var p=CFG;
  document.getElementById('p-title').textContent=p.title;
  document.getElementById('p-specline').textContent=p.specline;
  document.getElementById('p-status').textContent=p.status;
  document.getElementById('p-runline').textContent=p.runline;
  var nx=document.getElementById('p-next');nx.textContent=p.next.label;nx.setAttribute('href',p.next.url);
  document.getElementById('sb-status').textContent=p.statusShort||p.status;
  document.getElementById('arch-label').textContent=p.archLabel;
  document.getElementById('p-vitrine').textContent=p.vitrine;
  document.querySelector('.archive').style.display=(p.archive===false)?'none':'block';
  renderOpts();
  var s='';p.specs.forEach(function(r){s+='<div class="fg-row"><div class="k">'+r[0]+'</div><div class="v">'+r[1]+'</div></div>';});
  document.getElementById('p-specs').innerHTML=s;
  buildCarousel(p);
  var hero=document.getElementById('genic-jade-hero'),
      poster=document.getElementById('object-poster');
  var tg=document.getElementById('touch-gate');
  if(tg)tg.style.display='none';
  if(p.object==='v9'){
    if(hero)hero.style.display='block';
    poster.style.display='none';
  }else if(p.object==='cover'){
    if(hero)hero.style.display='none';
    poster.style.display='none';
    var host=document.getElementById('genic-tailsman-hero');
    var coarse=window.matchMedia('(pointer: coarse)').matches;
    if(host&&coarse&&tg){
      host.style.pointerEvents='none';
      tg.style.display='block';
      tg.addEventListener('click',function(){
        var on=host.style.pointerEvents==='none';
        host.style.pointerEvents=on?'auto':'none';
        tg.textContent=on?'DONE':'TAP TO HANDLE';
      });
    }
  }else{
    if(hero)hero.style.display='none';
    poster.style.display='block';
    poster.src=(p.options[selectedOpt]&&p.options[selectedOpt].poster)||p.poster;
    poster.style.width=(window.innerWidth<700&&p.posterWMobile)?p.posterWMobile:(p.posterW||'min(62%,420px)');
  }
})();
